import { MAINNET_ID, type NetworkId, SANDBOX_ID, TESTNET_ID } from "@akashnetwork/chain-sdk/web";

export const UAKT_DENOM = "uakt";
export const UACT_DENOM = "uact";
export const USDC_IBC_DENOMS = {
  [MAINNET_ID]: "ibc/170C677610AC31DF0904FFE09CD3B5C657492170E7E52372E48756B71E56F2F1",
  [SANDBOX_ID]: "ibc/028CD1864059EEFB48A6048376165318E3E82C234390AE5A6D7B22001725B06E",
  [TESTNET_ID]: "ibc/028CD1864059EEFB48A6048376165318E3E82C234390AE5A6D7B22001725B06E"
} satisfies Partial<Record<NetworkId, string>>;

const READABLE_AKT_DENOM = "uAKT";
const READABLE_USDC_DENOM = "uUSDC";
const READABLE_UACT_DENOM = "uACT";

export const READABLE_DENOMS = {
  [UAKT_DENOM]: READABLE_AKT_DENOM,
  [UACT_DENOM]: READABLE_UACT_DENOM,
  [USDC_IBC_DENOMS[MAINNET_ID]!]: READABLE_USDC_DENOM,
  [USDC_IBC_DENOMS[SANDBOX_ID]!]: READABLE_USDC_DENOM,
  [USDC_IBC_DENOMS[TESTNET_ID]!]: READABLE_USDC_DENOM
};
